module.exports = __webpack_public_path__ + "static/media/invalid-cart.114d54da.svg";